<template>
  <div>
    <CModal title="Modal title" :show.sync="modalVisible" modal-xl>
      sdfg
      sdf 
      dfs s dfg df gdf gd fgsd gdsfgggggggggggggggggggggggggggds dfs gdfs gds g sdfg ds df sdfg
      sdf 
      dfs s dfg df gdf gd fgsd gdsfgggggggggggggggggggggggggggds dfs gdfs gds g sdfg ds df sdfg
      sdf 
      dfs s dfg df gdf gd fgsd gdsfgggggggggggggggggggggggggggds dfs gdfs gds g sdfg ds df sdfg
      sdf 
      dfs s dfg df gdf gd fgsd gdsfgggggggggggggggggggggggggggds dfs gdfs gds g sdfg ds df sdfg
      sdf 
      dfs s dfg df gdf gd fgsd gdsfgggggggggggggggggggggggggggds dfs gdfs gds g sdfg ds df sdfg
      sdf 
      dfs s dfg df gdf gd fgsd gdsfgggggggggggggggggggggggggggds dfs gdfs gds g sdfg ds df sdfg
      sdf 
      dfs s dfg df gdf gd fgsd gdsfgggggggggggggggggggggggggggds dfs gdfs gds g sdfg ds df sdfg
      sdf 
      dfs s dfg df gdf gd fgsd gdsfgggggggggggggggggggggggggggds dfs gdfs gds g sdfg ds df sdfg
      sdf 
      dfs s dfg df gdf gd fgsd gdsfgggggggggggggggggggggggggggds dfs gdfs gds g sdfg ds df sdfg
      sdf 
      dfs s dfg df gdf gd fgsd gdsfgggggggggggggggggggggggggggds dfs gdfs gds g sdfg ds df sdfg
      sdf 
      dfs s dfg df gdf gd fgsd gdsfgggggggggggggggggggggggggggds dfs gdfs gds g sdfg ds df sdfg
      sdf 
      dfs s dfg df gdf gd fgsd gdsfgggggggggggggggggggggggggggds dfs gdfs gds g sdfg ds df sdfg
      sdf 
      dfs s dfg df gdf gd fgsd gdsfgggggggggggggggggggggggggggds dfs gdfs gds g sdfg ds df sdfg
      sdf 
      dfs s dfg df gdf gd fgsd gdsfgggggggggggggggggggggggggggds dfs gdfs gds g sdfg ds df sdfg
      sdf 
      dfs s dfg df gdf gd fgsd gdsfgggggggggggggggggggggggggggds dfs gdfs gds g sdfg ds df sdfg
      sdf 
      dfs s dfg df gdf gd fgsd gdsfgggggggggggggggggggggggggggds dfs gdfs gds g sdfg ds df sdfg
      sdf 
      dfs s dfg df gdf gd fgsd gdsfgggggggggggggggggggggggggggds dfs gdfs gds g sdfg ds df sdfg
      sdf 
      dfs s dfg df gdf gd fgsd gdsfgggggggggggggggggggggggggggds dfs gdfs gds g sdfg ds df sdfg
      sdf 
      dfs s dfg df gdf gd fgsd gdsfgggggggggggggggggggggggggggds dfs gdfs gds g sdfg ds df 
    </CModal>

    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <div class="flex">
              <h1>Lista zamówień</h1>
            </div>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="12">
                <CRow>
                  <CCol sm="12">
                    <table class="table">
                      <thead>
                        <tr>
                          <th scope="col" width="120">Numer</th>
                          <th scope="col" width="120">Data Złożenia</th>
                          <th scope="col" width="120">Kwota netto</th>
                          <th scope="col" width="120">Kwota brutto</th>
                          <th scope="col">Rabat</th>
                          <th scope="col">Nazwa firmy</th>
                          <th scope="col">VAT UE</th>
                          <th scope="col">Payu</th>
                          <th scope="col">Opłacone</th>
                          <th scope="col">Wysłane</th>
                          <th scope="col">Przekaż do e</th>
                          <th scope="col"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          class="datarow"
                          v-for="(item,index) in ordersData"
                          :key="item.id"
                          @click="mthShowOrderDetails(item,index)"
                        >
                          <td scope="col">{{item.nr_zamowienia}}</td>
                          <td scope="col">{{item.data}}</td>
                          <td
                            scope="col"
                            class="money nowrap"
                          >{{item.netto_z_wysylka_w_walucie_klienta}} {{item.waluta}}</td>
                          <td
                            scope="col"
                            class="money nowrap"
                          >{{item.brutto_z_wysylka_w_walucie_klienta}} {{item.waluta}}</td>
                          <td scope="col" class="number nowrap">
                            {{mthEmptyToZero(item.rabat)}}%
                            <template
                              v-if="item.przedsezonowe=='1'"
                            >(P)</template>
                          </td>
                          <td scope="col">{{mthPreprocessJsonStr(item.nazwafirmy)}}</td>
                          <td scope="col">{{item.vatUE | myfnodblquotes | myfzeroniejedentak }}</td>
                          <td
                            scope="col"
                            :class="mthGetPayuCssClassByState(item.payu_paid,item.platnosc)"
                          >{{mthPayuInterpreter(item.payu_paid,item.platnosc)}}</td>
                          <td scope="col" class="nowrap">
                            {{item.oplacone | myfzeroniejedentak }}
                            <CButton
                              @click="mthSetOrderPaid(item,index)"
                              v-if="item.oplacone.includes('0')"
                              color="light"
                              size="sm"
                              shape="pill"
                            >Oznacz</CButton>
                          </td>
                          <td scope="col">
                            {{item.wyslane | myfzeronieemptyniejedentak }}
                            <CButton
                              @click="mthSetOrderSent(item,index)"
                              v-if="item.wyslane != 1"
                              color="light"
                              size="sm"
                              shape="pill"
                            >Potwierdź</CButton>
                          </td>
                          <td scope="col">
                            {{item.przekaz_e | myfzeronieemptyniejedentak }}
                            <CButton
                              @click="mthSetEnovaFlag(item,index)"
                              v-if="item.przekaz_e != 1"
                              color="light"
                              size="sm"
                              shape="pill"
                            >Przekaż do E</CButton>
                          </td>
                          <td scope="col"></td>
                        </tr>
                      </tbody>
                    </table>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import MainChartExample from "./charts/MainChartExample";
import WidgetsDropdown from "./widgets/WidgetsDropdown";
import WidgetsBrand from "./widgets/WidgetsBrand";
import usersData from "./users/UsersData";
import CTableWrapper from "./base/Table.vue";
import globalFunctionsMixin from "../mixins/globalFunctionsMixin";

export default {
  name: "B2borders",
  mixins: [globalFunctionsMixin],
  components: {
    MainChartExample,
    WidgetsDropdown,
    WidgetsBrand,
    CTableWrapper,
  },
  created() {
    this.mthFillOrdersData();

    console.log("should be:");
    console.log(this.ordersData0);
  },
  data() {
    return {
      refresher: 0,
      ordersData: [],
      modalVisible: false,
    };
  },
  methods: {
    mthShowOrderDetails(item, index) {
      this.modalVisible = true;
    },
    mthSetEnovaFlag(item, index) {
      if (confirm("Czy chcesz przekazać to zamówienie do Enova?")) {
        var apiurl =
          process.env.VUE_APP_API_URL + "/b2bsetorderenova?id=" + item.id;

        var that = this;

        this.$axios({
          method: "get",
          url: apiurl,
        })
          .then(function (response) {
            //console.log("response:");
            console.log(response.data);

            //that.ordersData = response.data;
            if (response.data.includes("ok")) {
              //that.ordersData[index].oplacone=1;
              that.$set(that.ordersData[index], "przekaz_e", "1");
              that.mthKickRefresher();
            }
          })
          .catch(function (error) {
            console.log(error);
            that.loginsuccess = false;
            that.loginresultmsg = "Brak połączenia z API (" + error + ").";
          });
      }
    },
    mthSetOrderSent(item, index) {
      if (confirm("Czy oznaczyć jako wyslane?")) {
        var apiurl =
          process.env.VUE_APP_API_URL + "/b2bsetordersent?id=" + item.id;

        var that = this;

        this.$axios({
          method: "get",
          url: apiurl,
        })
          .then(function (response) {
            //console.log("response:");
            console.log(response.data);

            //that.ordersData = response.data;
            if (response.data.includes("ok")) {
              //that.ordersData[index].oplacone=1;
              that.$set(that.ordersData[index], "wyslane", "1");
              that.mthKickRefresher();
            }
          })
          .catch(function (error) {
            console.log(error);
            that.loginsuccess = false;
            that.loginresultmsg = "Brak połączenia z API (" + error + ").";
          });
      }
    },
    mthKickRefresher() {
      var miliseconds = new Date().getTime();
      this.refresher = miliseconds;
    },
    mthSetOrderPaid(item, index) {
      if (confirm("Czy oznaczyć jako zapłacone?")) {
        var apiurl =
          process.env.VUE_APP_API_URL + "/b2bsetorderpaid?id=" + item.id;

        var that = this;

        this.$axios({
          method: "get",
          url: apiurl,
        })
          .then(function (response) {
            //console.log("response:");
            console.log(response.data);

            //that.ordersData = response.data;
            if (response.data.includes("ok")) {
              console.log("setting oplacone to 1");
              //that.ordersData[index].oplacone=1;
              that.$set(that.ordersData[index], "oplacone", "1");
              that.mthKickRefresher();
            }
          })
          .catch(function (error) {
            console.log(error);
            that.loginsuccess = false;
            that.loginresultmsg = "Brak połączenia z API (" + error + ").";
          });
      }
    },
    mthPayuInterpreter(payu_paid, platnosc) {
      if (payu_paid == 1) return "ZAPŁ.";
      else if (payu_paid == -1) return "NIE ZAPŁ.";
      else if (platnosc.includes("PayU")) return "TAK";
    },
    mthGetPayuCssClassByState(payu_paid, platnosc) {
      if (payu_paid == 1) return "bggreen";
      else if (payu_paid == -1) return "bgred";
      else if (platnosc.includes("PayU")) return "bgyellow";
    },
    mthPreprocessJsonStr(arg) {
      var ret = arg.replace('"', "");
      ret = ret.replace('"', "");
      ret = ret.replace('"', "");
      ret = ret.replace('"', "");
      ret = ret.replace('"', "");
      ret = ret.replace('"', "");

      ret = this.mthGlobalConvertUnicodeCharsToUtf8Text(ret);

      //return ret;

      //ret=ret.replace(/[\u00A0-\u00FF]/g, function(c) {return '&#'+c.charCodeAt(0)+';';});

      //ret=this.$utf8.decode(ret);

      //ret=ret.normalize();

      //console.log(this.$unorm.nfc(ret));

      //return this.$unorm.nfkc(ret);// ret.normalize('NFKD')+'b';

      //return ret.normalize('NFKD');

      //console.log('\u0141')

      return ret;
    },
    mthEmptyToZero(arg) {
      if (arg == "") return 0;
      if (arg == "null") return 0;
      if (arg == null) return 0;
      return arg;
    },
    mthFillOrdersData() {
      var apiurl = process.env.VUE_APP_API_URL + "/ordersb2b";

      var that = this;

      this.$axios({
        method: "get",
        url: apiurl,
      })
        .then(function (response) {
          console.log("response:");
          console.log(response.data);
          that.ordersData = response.data;
        })
        .catch(function (error) {
          console.log(error);
          that.loginsuccess = false;
          that.loginresultmsg = "Brak połączenia z API (" + error + ").";
        });
    },
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        let temp = array[i];
        array[i] = array[j];
        array[j] = temp;
      }
      return array;
    },

    getShuffledOrdersData() {
      return this.shuffleArray(this.ordersData.slice(0));
    },

    color(value) {
      let $color;
      if (value <= 25) {
        $color = "info";
      } else if (value > 25 && value <= 50) {
        $color = "success";
      } else if (value > 50 && value <= 75) {
        $color = "warning";
      } else if (value > 75 && value <= 100) {
        $color = "danger";
      }
      return $color;
    },
  },
};
</script>
<style scoped>
.money {
  text-align: right;
}
.nowrap {
  white-space: nowrap;
}
.number {
  text-align: right;
}
.bggreen {
  background-color: greenyellow;
}
.bgyellow {
  background-color: yellow;
}
.bgred {
  background-color: red;
}
.datarow:hover {
  background-color: lightsalmon;
}


</style>>
